
const PopUpComponent = ({
  children,
  isVisible,
  setVisible,
  title = "Title placeholder",
  showHeader,
  headerComponent,
  classNames = "",
}) => {

  //console.log("render with ", classNames)
  return (
    <>
      {isVisible && (
        <div className="row justify-content-center" >
          <div className="popup-back col-12"/>
          <div className="col-2 ">
            <div className="popup-overlay  "    >

              <div className={"popup-container wide " + classNames}
                style={{
                  maxHeight: '85%',
                  overflow: 'scroll'
                }}
              >
                {showHeader && (
                  <div className="popup-container__header">
                    {headerComponent != null ? headerComponent() :  <h3>{title}</h3> }
                  </div>
                )}

                <button
                  className="popup-container__button"
                  onClick={() => setVisible(false)}
                  style={{
                    color: "black",
                    fontSize: "1.2rem",
                    border: "none",
                    fontWeight: "bold",
                  }}
                >
                  X
                </button>
                <div style={{ height: "auto" }}>
                  {children}


                </div>

              </div>

            </div>
          </div>
        </div>
      )}
    </>
  );

};

export default PopUpComponent;


export const BarePopUp = ({
  children,
  isVisible,
  setVisible,
  title = "Title placeholder",
  showHeader,
  classNames = "",
}) => {

  //console.log("render with ", classNames)
  return (
    <>
      {isVisible && (
        <div className="row justify-content-center" >
          <div className="popup-back col-12" onClick={() => setVisible(false)} />
          <div className="col-2 ">
            <div className="popup-overlay bare " >

              <div className={"popup-container " + classNames}
              >
                {showHeader && (
                  <div>
                    <div className="popup-container__header">
                      <h3>{title}</h3>
                    </div>
                    <button
                      className="popup-container__button"
                      onClick={() => setVisible(false)}
                      style={{
                        color: "black",
                        fontSize: "1.2rem",
                        border: "none",
                        fontWeight: "bold",
                      }}
                    >
                      X
                    </button>
                  </div>
                )}


                <div style={{ height: "auto" }}>
                  {children}
                </div>

              </div>

            </div>
          </div>
        </div>
      )}
    </>
  );

};
